import { z } from 'zod';
import { ConfigSettingsAddForm, makeConfigSettingAddSchema } from '@/shared/components/config-settings';
import { ConfigOptionCombobox } from '@/features/smr-admin/components/ConfigOptionCombobox';
import type { ConfigOptionRecord } from '@/features/smr-admin/services/smr-admin';
import type { useConfigSettingMutations } from '../hooks/useConfigSettingMutations';

const addSchema = makeConfigSettingAddSchema({
    keySchema: z.string().min(1, 'Select a catalog setting').max(255),
});

interface Props {
    mutations: ReturnType<typeof useConfigSettingMutations>;
    onDone?: () => void;
    /** Option ids already applied to the product; hidden from the search to prevent duplicates. */
    excludeOptionIds?: string[];
    isOptionAvailable?: (option: ConfigOptionRecord) => boolean;
}

export function ConfigSettingAddForm({ mutations, onDone, excludeOptionIds = [], isOptionAvailable }: Props) {
    return (
        <ConfigSettingsAddForm<ConfigOptionRecord>
            schema={addSchema}
            mutations={mutations}
            onDone={onDone}
            excludeOptionIds={excludeOptionIds}
            renderCatalogPicker={({ id, value, onChange, excludeIds }) => (
                <ConfigOptionCombobox
                    id={id}
                    value={value}
                    onChange={onChange}
                    excludeIds={excludeIds}
                    isOptionAvailable={isOptionAvailable}
                    placeholder="Search catalog options…"
                />
            )}
        />
    );
}
